import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ApiService {


  apiUrl = window.location.hostname.indexOf('localhost') !== -1 ? 'http://localhost:8080' : '/api/';


  constructor(protected httpClient: HttpClient) {

  }

  get(path: string, params?: any): Observable<any> {
      return this.httpClient.get(`${this.apiUrl}/${path}`);
  }

  post(path: string, body:any, params?: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/${path}`, body);
  }

}
